(function () {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const shopRoot = window.Shopify?.routes?.root || '/';

  const positionProductDetailStory = () => {
    const anchor = qs('.lumi-pdp-editorial');
    const stories = qsa('.lumi-detail-story');
    if (!anchor || !stories.length) return;
    const story = stories.find((item) => item.closest('.lumi-pdp__shell')) || stories[0];
    if (story.nextElementSibling !== anchor) anchor.before(story);
    stories.forEach((item) => { if (item !== story) item.remove(); });
  };
  positionProductDetailStory();
  document.addEventListener('shopify:section:load', () => positionProductDetailStory());

  const header = qs('[data-lumi-header]');
  const setHeaderState = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  const desktopMegaMenu = window.matchMedia('(min-width: 990px)');
  const megaMenuItems = qsa('[data-lumi-mega-item]');
  megaMenuItems.forEach((item) => {
    const trigger = qs('[data-lumi-mega-trigger]', item);
    let closeTimer;

    const setMegaMenu = (isOpen) => {
      item.classList.toggle('is-open', isOpen);
      trigger?.setAttribute('aria-expanded', String(isOpen));
    };
    const openMegaMenu = () => {
      if (!desktopMegaMenu.matches) return;
      window.clearTimeout(closeTimer);
      item.classList.remove('is-escape-closed');
      setMegaMenu(true);
    };
    const closeMegaMenu = (immediate = false) => {
      window.clearTimeout(closeTimer);
      if (immediate) {
        setMegaMenu(false);
        return;
      }
      closeTimer = window.setTimeout(() => setMegaMenu(false), 160);
    };

    item.addEventListener('mouseenter', openMegaMenu);
    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-escape-closed');
      closeMegaMenu();
    });
    item.addEventListener('focusin', () => {
      if (item.classList.contains('is-escape-closed')) return;
      openMegaMenu();
    });
    item.addEventListener('focusout', (event) => {
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      item.classList.remove('is-escape-closed');
      closeMegaMenu();
    });
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      item.classList.add('is-escape-closed');
      closeMegaMenu(true);
      trigger?.focus({ preventScroll: true });
    });

    const resetMegaMenu = () => {
      if (!desktopMegaMenu.matches) closeMegaMenu(true);
    };
    if (typeof desktopMegaMenu.addEventListener === 'function') {
      desktopMegaMenu.addEventListener('change', resetMegaMenu);
    } else {
      desktopMegaMenu.addListener(resetMegaMenu);
    }
  });

  const menuToggle = qs('[data-lumi-menu-toggle]');
  const mobileMenu = qs('[data-lumi-mobile-menu]');
  const setMobileMenu = (isOpen) => {
    if (!menuToggle || !mobileMenu) return;
    menuToggle.classList.toggle('is-open', isOpen);
    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    mobileMenu.classList.toggle('is-open', isOpen);
    mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('lumi-menu-open', isOpen);
  };
  const openMobileMenu = () => setMobileMenu(true);
  const closeMobileMenu = () => setMobileMenu(false);
  menuToggle?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    setMobileMenu(!mobileMenu?.classList.contains('is-open'));
  });
  qsa('[data-lumi-menu-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeMobileMenu();
    });
  });
  qsa('.lumi-mobile-menu__links a, .lumi-mobile-menu__cta a').forEach((link) => {
    link.addEventListener('click', () => closeMobileMenu());
  });
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu();
  });

  const toast = qs('[data-lumi-toast]');
  const showToast = (message = 'Added to cart successfully.') => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  const openModal = (name) => {
    const modal = qs(`[data-lumi-modal="${name}"]`);
    if (!modal) return;
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
  };
  const closeModal = (button) => {
    const modal = button.closest('dialog');
    if (!modal) return;
    if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
  };

  qsa('[data-lumi-open-ar]').forEach((el) => el.addEventListener('click', (event) => {
    if (event.currentTarget.closest('[data-lumi-header]')) return;
    openModal('ar');
  }));
  qsa('[data-lumi-open-custom-entry]').forEach((el) => el.addEventListener('click', () => openModal('custom-entry')));
  qsa('[data-lumi-open-customizer]').forEach((el) => el.addEventListener('click', () => openModal('customizer')));
  qsa('[data-lumi-open-style-finder]').forEach((el) => el.addEventListener('click', () => openModal('style')));
  qsa('[data-lumi-close-modal]').forEach((el) => el.addEventListener('click', () => closeModal(el)));
  qsa('.lumi-modal').forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
  });

  const formatDesignFileSize = (bytes) => {
    if (!Number.isFinite(bytes) || bytes <= 0) return '';
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  qsa('[data-lumi-modal="custom-entry"]').forEach((modal) => {
    const fileInput = qs('[data-lumi-design-file]', modal);
    const fileName = qs('[data-lumi-design-file-name]', modal);
    const sendButton = qs('[data-lumi-email-design]', modal);
    const status = qs('[data-lumi-design-file-status]', modal);
    const maxFileSize = 20 * 1024 * 1024;

    if (!fileInput || !fileName || !sendButton || !status) return;

    const resetFileState = (message = '') => {
      const defaultText = fileName.dataset.defaultText || 'PDF, image, CAD or ZIP - up to 20 MB';
      fileName.textContent = defaultText;
      sendButton.disabled = true;
      status.textContent = message;
    };

    fileInput.addEventListener('change', () => {
      const file = fileInput.files?.[0];
      if (!file) {
        resetFileState();
        return;
      }
      if (file.size > maxFileSize) {
        fileInput.value = '';
        resetFileState('Please choose a file smaller than 20 MB.');
        return;
      }
      fileName.textContent = `${file.name} - ${formatDesignFileSize(file.size)}`;
      sendButton.disabled = false;
      status.textContent = '';
    });

    sendButton.addEventListener('click', async () => {
      const file = fileInput.files?.[0];
      if (!file) {
        resetFileState('Choose a design file before continuing.');
        return;
      }

      const shareData = {
        files: [file],
        title: 'Custom Lighting Design - Solena Lighting',
        text: `Custom lighting design file: ${file.name}`
      };

      let canShareFile = false;
      try {
        canShareFile = Boolean(navigator.share && navigator.canShare?.({ files: [file] }));
      } catch (error) {
        canShareFile = false;
      }

      if (canShareFile) {
        try {
          await navigator.share(shareData);
          status.textContent = 'Your design file is ready to send from the app you selected.';
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }

      const email = sendButton.dataset.email || 'support@solenalighting.com';
      const subject = encodeURIComponent('Custom Lighting Design - Solena Lighting');
      const body = encodeURIComponent(`Hello Solena Lighting,\n\nI would like to request a custom light based on my design file: ${file.name}.\n\nPlease find the design file attached to this email.\n\nName:\nProject location:\nProject notes:\n`);
      status.textContent = `Your email app is opening. Please attach ${file.name} before sending.`;
      window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    });
  });

  const hero = qs('[data-lumi-hero]');
  if (hero) {
    const slides = qsa('.lumi-hero-slide', hero);
    const dots = qsa('[data-lumi-hero-dots] button', hero);
    const progress = qs('[data-lumi-hero-progress]', hero);
    let index = 0;
    let touchStart = 0;
    const duration = 5000;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      if (progress) {
        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = `lumiHeroProgress ${duration}ms linear forwards`;
      }
    };
    const next = () => show(index + 1);
    const prev = () => show(index - 1);
    qs('[data-lumi-hero-next]', hero)?.addEventListener('click', next);
    qs('[data-lumi-hero-prev]', hero)?.addEventListener('click', prev);
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
    hero.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 40) (delta < 0 ? next : prev)();
    }, { passive: true });
    show(0);
    window.setInterval(next, duration);
  }

  const cartDrawer = qs('[data-lumi-cart-drawer]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  };
  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  };
  qsa('[data-lumi-cart-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openCart();
    });
  });
  qsa('[data-lumi-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  cartDrawer?.addEventListener('click', (event) => {
    if (event.target === cartDrawer) closeCart();
  });

  const refreshCartDrawer = async () => {
    try {
      const response = await fetch(`${shopRoot}cart.js`);
      const cart = await response.json();
      qsa('[data-lumi-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      const drawerCount = qs('[data-lumi-drawer-count]');
      if (drawerCount) drawerCount.textContent = `${cart.item_count} items`;
      const subtotal = qs('[data-lumi-cart-subtotal]');
      if (subtotal && window.Shopify?.formatMoney) subtotal.textContent = Shopify.formatMoney(cart.total_price);
      const items = qs('[data-lumi-cart-items]');
      if (!items) return;
      if (!cart.items.length) {
        items.innerHTML = '<p class="lumi-cart-drawer__empty">Your cart is empty.</p>';
        return;
      }
      items.innerHTML = cart.items.map((item) => `
        <article class="lumi-drawer-line">
          <img src="${item.image || ''}" alt="${item.product_title}" loading="lazy">
          <div><strong>${item.product_title}</strong><span>${item.variant_title || ''}</span><small>${window.Shopify?.formatMoney ? Shopify.formatMoney(item.final_price) : ''}</small><div class="lumi-drawer-qty"><button type="button" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" aria-label="Increase quantity">+</button></div></div>
          <a href="${shopRoot}cart/change?id=${item.key}&quantity=0" aria-label="Remove ${item.product_title}">x</a>
        </article>
      `).join('');
    } catch (error) {
      console.warn('Cart refresh failed', error);
    }
  };

  const ajaxAdd = async (form) => {
    const body = new FormData(form);
    const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to add item');
    await response.json();
    await refreshCartDrawer();
    showToast('Added to cart successfully.');
    openCart();
  };

  window.SolenaCart = {
    addItem: async ({ id, quantity = 1 }) => {
      const body = new FormData();
      body.append('id', id);
      body.append('quantity', String(quantity));
      const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to add item');
      const addedItem = await response.json();
      await refreshCartDrawer();
      showToast('Added to cart successfully.');
      openCart();
      return addedItem;
    },
    refresh: refreshCartDrawer,
    open: openCart,
  };

  qsa('.lumi-quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      try { await ajaxAdd(form); }
      catch (error) { showToast('Please choose options on product page'); }
    });
  });

  const quickModal = qs('[data-lumi-modal="quick-view"]');
  const quickContent = qs('[data-lumi-quick-view-content]');
  qsa('[data-lumi-quick-view]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!quickContent) return;
      const title = button.dataset.title || 'Product';
      const price = button.dataset.price || '';
      const image = button.dataset.image || '';
      const url = button.dataset.url || '#';
      const variantId = button.dataset.variantId || '';
      quickContent.innerHTML = `
        <img src="${image}" alt="${title}">
        <div>
          <h2>${title}</h2>
          <strong>${price}</strong>
          <label>Wood tone<select><option>Natural Ash</option><option>Oak</option><option>Walnut</option><option>Black Ash</option></select></label>
          <label>Size<select><option>Small</option><option>Medium</option><option>Large</option></select></label>
          <label>Quantity<input type="number" min="1" value="1"></label>
          <button type="button" class="lumi-btn lumi-btn--dark" data-lumi-quick-modal-add>Add To Cart</button>
          <a class="lumi-btn lumi-btn--cream" href="${url}">View Full Details</a>
        </div>
      `;
      qs('[data-lumi-quick-modal-add]', quickContent)?.addEventListener('click', async () => {
        if (!variantId) {
          window.location.href = url;
          return;
        }
        const form = new FormData();
        form.append('id', variantId);
        form.append('quantity', '1');
        try {
          const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', body: form, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Unable to add');
          await refreshCartDrawer();
          showToast('Added to cart successfully.');
          quickModal?.close();
          openCart();
        } catch (error) {
          showToast('Please choose options on product page');
        }
      });
      openModal('quick-view');
    });
  });

  qsa('[data-lumi-toast-button]').forEach((button) => button.addEventListener('click', () => showToast('Saved to your design board')));

  qsa('[data-lumi-swatch]').forEach((swatch) => {
    swatch.addEventListener('click', () => {
      const card = swatch.closest('.lumi-product-card');
      const swatches = swatch.closest('.lumi-product-card__swatches');
      qsa('[data-lumi-swatch]', swatches).forEach((item) => item.classList.remove('is-active'));
      swatch.classList.add('is-active');
      if (card) card.dataset.tone = swatch.dataset.lumiSwatch || '';
    });
  });

  qsa('.lumi-custom-step button').forEach((button) => {
    button.addEventListener('click', () => {
      qsa('button', button.closest('.lumi-custom-step')).forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
      const preview = qs('[data-lumi-custom-preview]');
      if (preview && button.dataset.tone) preview.dataset.tone = button.dataset.tone;
    });
  });

  const initializeProductPage = (productPage) => {
    if (!productPage || productPage.dataset.lumiProductInitialized === 'true') return;
    productPage.dataset.lumiProductInitialized = 'true';

    const mediaGrid = qs('[data-lumi-product-media-grid]', productPage);
    const mediaItems = qsa('[data-lumi-product-media-item]', productPage);
    const activeMediaContainer = qs('[data-lumi-active-media-container]', productPage);
    const activeMediaTemplates = qsa('[data-lumi-active-media-template]', productPage);
    const desktopProductGallery = window.matchMedia('(min-width: 990px)');
    const mediaDialog = qs('[data-lumi-product-media-dialog]', productPage);
    const zoomImage = qs('[data-lumi-product-zoom-image]', productPage);
    const zoomPanel = qs('[data-lumi-product-zoom-panel]', productPage);
    const videoPanel = qs('[data-lumi-product-video-panel]', productPage);

    const getGalleryImageIdentity = (src) => {
      if (!src) return '';
      try {
        return new URL(src, window.location.href).pathname;
      } catch (_error) {
        return String(src).split('?')[0];
      }
    };

    const findMediaItem = (mediaId) =>
      mediaItems.find((item) => item.dataset.mediaId === String(mediaId || ''));

    const findActiveMediaTemplate = (mediaId) =>
      activeMediaTemplates.find(
        (template) => template.dataset.lumiActiveMediaTemplate === String(mediaId || '')
      );

    const setupActiveShopifyXR = () => {
      if (!window.ShopifyXR) return;
      const modelJSON = qs('[id^="ProductModelJSON-"]', productPage);
      if (modelJSON && productPage.dataset.lumiXrModelsAdded !== 'true') {
        try {
          window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent || '[]'));
          productPage.dataset.lumiXrModelsAdded = 'true';
        } catch (_error) {
          // Keep the model viewer available when ShopifyXR metadata is invalid.
        }
      }
      window.ShopifyXR.setupXRElements();
    };

    const loadActiveShopifyXR = () => {
      if (window.ShopifyXR) {
        setupActiveShopifyXR();
        return;
      }
      if (!window.Shopify?.loadFeatures || productPage.dataset.lumiXrLoading === 'true') return;
      productPage.dataset.lumiXrLoading = 'true';
      document.addEventListener('shopify_xr_initialized', setupActiveShopifyXR, { once: true });
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupActiveShopifyXR,
        },
      ]);
    };

    const renderActiveMedia = (mediaId) => {
      if (!activeMediaContainer || !desktopProductGallery.matches) return;
      const template = findActiveMediaTemplate(mediaId);
      if (!(template instanceof HTMLTemplateElement)) return;

      activeMediaContainer.replaceChildren(template.content.cloneNode(true));
      activeMediaContainer.dataset.activeMediaId = String(mediaId);
      activeMediaContainer.dataset.mediaType = template.dataset.mediaType || '';
      activeMediaContainer.dataset.imageSrc = template.dataset.imageSrc || '';
      activeMediaContainer.dataset.imageAlt = template.dataset.imageAlt || '';
      activeMediaContainer.classList.toggle('lumi-pdp__active-media--contain', template.dataset.mediaFit === 'contain');
      activeMediaContainer.classList.toggle('lumi-pdp__active-media--cover', template.dataset.mediaFit === 'cover');

      if (template.dataset.mediaType === 'image') {
        activeMediaContainer.setAttribute('role', 'button');
        activeMediaContainer.setAttribute('tabindex', '0');
        activeMediaContainer.setAttribute('aria-label', `Enlarge ${template.dataset.imageAlt || 'product image'}`);
      } else {
        activeMediaContainer.removeAttribute('role');
        activeMediaContainer.removeAttribute('tabindex');
        activeMediaContainer.removeAttribute('aria-label');
      }

      if (template.dataset.mediaType === 'model') {
        window.requestAnimationFrame(loadActiveShopifyXR);
      }
    };

    const syncMediaItems = (mediaId) => {
      const activeMediaId = String(mediaId || '');
      mediaItems.forEach((item) => {
        const isActive = item.dataset.mediaId === activeMediaId;
        item.hidden = desktopProductGallery.matches && isActive;
        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-active-duplicate', isActive);
        item.setAttribute('aria-current', String(isActive));
      });
    };

    const setActiveMedia = (
      mediaId,
      { scrollMobile = false, scrollDesktop = false, behavior = 'smooth' } = {}
    ) => {
      const mediaItem = findMediaItem(mediaId);
      if (!mediaItem || !activeMediaContainer) return;
      const activeMediaId = mediaItem.dataset.mediaId;
      activeMediaContainer.dataset.activeMediaId = activeMediaId;
      syncMediaItems(activeMediaId);

      if (desktopProductGallery.matches) {
        renderActiveMedia(activeMediaId);
        if (scrollDesktop) {
          activeMediaContainer.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior,
            block: 'nearest',
          });
        }
        return;
      }

      activeMediaContainer.replaceChildren();
      if (scrollMobile && mediaGrid) {
        mediaGrid.scrollTo({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior,
          left: mediaItem.offsetLeft,
        });
      }
    };

    let mediaScrollFrame = 0;
    mediaGrid?.addEventListener(
      'scroll',
      () => {
        if (!window.matchMedia('(max-width: 989px)').matches || mediaScrollFrame) return;
        mediaScrollFrame = window.requestAnimationFrame(() => {
          mediaScrollFrame = 0;
          const gridLeft = mediaGrid.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          mediaItems.forEach((item, index) => {
            const distance = Math.abs(item.getBoundingClientRect().left - gridLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          setActiveMedia(mediaItems[closestIndex]?.dataset.mediaId);
        });
      },
      { passive: true }
    );

    const initialActiveMediaId =
      activeMediaContainer?.dataset.activeMediaId || mediaItems[0]?.dataset.mediaId || '';
    setActiveMedia(initialActiveMediaId, {
      scrollMobile: true,
      behavior: 'auto',
    });

    desktopProductGallery.addEventListener('change', () => {
      setActiveMedia(activeMediaContainer?.dataset.activeMediaId || initialActiveMediaId, {
        scrollMobile: !desktopProductGallery.matches,
        behavior: 'auto',
      });
    });

    const openMediaDialog = (mode) => {
      if (!mediaDialog) return;
      if (zoomPanel) zoomPanel.hidden = mode !== 'image';
      if (videoPanel) videoPanel.hidden = mode !== 'video';
      if (typeof mediaDialog.showModal === 'function') mediaDialog.showModal();
      else mediaDialog.setAttribute('open', '');
      document.body.classList.add('lumi-modal-open');
    };
    const closeMediaDialog = () => {
      if (!mediaDialog) return;
      if (typeof mediaDialog.close === 'function') mediaDialog.close();
      else mediaDialog.removeAttribute('open');
      document.body.classList.remove('lumi-modal-open');
      qsa('video', mediaDialog).forEach((video) => video.pause());
    };

    const openImageDialog = (src, alt = '') => {
      if (zoomImage && src) {
        zoomImage.src = src;
        zoomImage.alt = alt;
      }
      openMediaDialog('image');
    };

    mediaItems.forEach((item) => {
      const openPreview = () => openImageDialog(item.dataset.imageSrc, item.dataset.imageAlt || '');
      item.addEventListener('click', (event) => {
        if (desktopProductGallery.matches) {
          event.preventDefault();
          event.stopPropagation();
          setActiveMedia(item.dataset.mediaId, { scrollDesktop: true });
          return;
        }
        if (item.dataset.mediaType === 'image') openPreview();
      }, true);
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (item.dataset.mediaType !== 'image' && !desktopProductGallery.matches) return;
        event.preventDefault();
        if (desktopProductGallery.matches) {
          setActiveMedia(item.dataset.mediaId, { scrollDesktop: true });
        } else {
          openPreview();
        }
      });
    });

    activeMediaContainer?.addEventListener('click', () => {
      if (activeMediaContainer.dataset.mediaType !== 'image') return;
      openImageDialog(activeMediaContainer.dataset.imageSrc, activeMediaContainer.dataset.imageAlt || '');
    });
    activeMediaContainer?.addEventListener('keydown', (event) => {
      if (
        activeMediaContainer.dataset.mediaType !== 'image' ||
        (event.key !== 'Enter' && event.key !== ' ')
      ) return;
      event.preventDefault();
      openImageDialog(activeMediaContainer.dataset.imageSrc, activeMediaContainer.dataset.imageAlt || '');
    });

    qs('[data-lumi-open-product-video]', productPage)?.addEventListener('click', () => openMediaDialog('video'));
    qs('[data-lumi-close-product-media]', productPage)?.addEventListener('click', closeMediaDialog);
    mediaDialog?.addEventListener('click', (event) => {
      if (event.target === mediaDialog) closeMediaDialog();
    });
    mediaDialog?.addEventListener('close', () => document.body.classList.remove('lumi-modal-open'));

    const variantsScript = qs('[data-lumi-product-variants]', productPage);
    const specificationMapScript = qs('[data-lumi-product-specification-map]', productPage);
    const variantModelsScript = qs('[data-lumi-variant-models]', productPage);
    const variantSelect = qs('[data-lumi-variant-select]', productPage);
    const optionGroups = qsa('[data-lumi-option-group]', productPage);
    const price = qs('[data-lumi-product-price]', productPage);
    const addButton = qs('[data-lumi-product-add]', productPage);
    const addLabel = qs('span', addButton);
    const skuNodes = qsa('[data-lumi-product-sku]', productPage);
    const skuRows = qsa('[data-lumi-product-sku-row]', productPage);
    const specificationRows = qsa('[data-lumi-specification-row]', productPage);
    const specificationValueNodes = qsa('[data-lumi-specification-value]', productPage);
    const availability = qs('[data-lumi-product-availability]', productPage);
    const product3dTrigger = qs('[data-lumi-product-3d-trigger]', productPage);
    const productModelExperience = qs('[data-lumi-product-experience-model]', productPage);
    const productArTrigger = qs('[data-lumi-product-ar-trigger]', productPage);
    const productCustomizeLink = qs('[data-lumi-product-customize-link]', productPage);
    let variants = [];
    let specificationMap = {};
    let variantModels = {};
    try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; }
    catch (error) { variants = []; }
    try { specificationMap = specificationMapScript ? JSON.parse(specificationMapScript.textContent) : {}; }
    catch (error) { specificationMap = {}; }
    try { variantModels = variantModelsScript ? JSON.parse(variantModelsScript.textContent) : {}; }
    catch (error) { variantModels = {}; }

    const formatMoney = (cents) => {
      const currency = productPage.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const selectedOptions = () => optionGroups.map((group) => qs('.is-selected', group)?.dataset.lumiOptionValue || '');
    const validSku = (value) => {
      const normalizedValue = String(value || '').trim();
      const normalizedComparison = normalizedValue.toLowerCase();
      if (!normalizedValue || normalizedComparison === 'n/a' || normalizedComparison === 'default title') return '';
      return normalizedValue;
    };
    const normalizeSpecificationValue = (value, key) => {
      if (typeof value !== 'string' && typeof value !== 'number') return '';
      const normalizedValue = String(value).trim();
      const normalizedComparison = normalizedValue.toLowerCase();
      if (!normalizedValue || normalizedComparison === 'default title') return '';
      if (key === 'finish' && normalizedComparison === 'one size') return '';
      return normalizedValue;
    };
    const specificationValue = (variant, key) => {
      const optionIndex = specificationMap[`${key}Index`];
      const optionValue =
        Number.isInteger(optionIndex) && optionIndex >= 0 && Array.isArray(variant.options)
          ? variant.options[optionIndex]
          : '';
      return normalizeSpecificationValue(
        optionValue || specificationMap[`${key}Fallback`] || '',
        key
      );
    };
    const updateSpecificationValue = (key, value) => {
      specificationValueNodes
        .filter((node) => node.dataset.lumiSpecificationValue === key)
        .forEach((node) => {
          node.textContent = value;
        });
      specificationRows
        .filter((row) => row.dataset.lumiSpecificationRow === key)
        .forEach((row) => {
          row.hidden = !value;
        });
    };
    const updateVariant = () => {
      const selected = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => String(value) === selected[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (variantSelect) {
        variantSelect.value = String(variant.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (price) price.textContent = formatMoney(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      const variantSku = validSku(variant.sku);
      skuNodes.forEach((skuNode) => {
        skuNode.textContent = variantSku;
      });
      skuRows.forEach((skuRow) => {
        skuRow.hidden = !variantSku;
      });
      const finishValue = specificationValue(variant, 'finish');
      let sizeValue = specificationValue(variant, 'size');
      let configurationValue = specificationValue(variant, 'configuration');
      if (sizeValue === finishValue) sizeValue = '';
      if (configurationValue === finishValue || configurationValue === sizeValue) configurationValue = '';
      updateSpecificationValue('finish', finishValue);
      updateSpecificationValue('size', sizeValue);
      updateSpecificationValue('configuration', configurationValue);
      if (availability) availability.textContent = variant.available ? 'In stock' : 'Sold out';
      productPage.dataset.currentVariantId = String(variant.id);
      if (product3dTrigger) {
        const variantModel = variantModels[String(variant.id)] || {};
        const variantGlbUrl = variantModel.glbUrl || '';
        const variantUsdzUrl = variantModel.usdzUrl || '';
        product3dTrigger.dataset.modelUrl = variantGlbUrl;
        product3dTrigger.dataset.iosModelUrl = variantUsdzUrl;
        product3dTrigger.hidden = !variantGlbUrl;
        product3dTrigger.setAttribute('aria-hidden', String(!variantGlbUrl));
        const viewer = qs('[data-lumi-model-viewer]', productPage);
        if (viewer) {
          viewer.dataset.modelUrl = variantGlbUrl;
          viewer.dataset.iosModelUrl = variantUsdzUrl;
        }
        if (productModelExperience) productModelExperience.hidden = !variantGlbUrl;
        if (!variantGlbUrl) {
          const openDialog = qs('[data-lumi-product-3d-dialog]', productPage);
          if (openDialog?.open) closeProduct3d(openDialog);
        }
      }
      if (productArTrigger) {
        const variantModel = variantModels[String(variant.id)] || {};
        const variantGlbUrl = variantModel.glbUrl || '';
        const variantUsdzUrl = variantModel.usdzUrl || '';
        productArTrigger.dataset.modelUrl = variantGlbUrl;
        productArTrigger.dataset.iosModelUrl = variantUsdzUrl;
        productArTrigger.hidden = !variantGlbUrl;
        productArTrigger.setAttribute('aria-hidden', String(!variantGlbUrl));
      }
      [productCustomizeLink].forEach((link) => {
        if (!link) return;
        const destination = new URL(link.href, window.location.origin);
        destination.searchParams.set('product', productPage.dataset.productHandle || '');
        destination.searchParams.set('variant', String(variant.id));
        link.href = destination.toString();
      });
      if (mediaItems.length) {
        const variantMediaId = String(
          variant.featured_media?.id ||
          variant.featured_image?.id ||
          productPage.dataset.fallbackMediaId ||
          ''
        );
        const variantImageIdentity = getGalleryImageIdentity(variant.featured_image?.src);
        const variantMediaIndex = mediaItems.findIndex((item) => {
          if (variantMediaId && item.dataset.mediaId === variantMediaId) return true;
          return Boolean(variantImageIdentity) &&
            getGalleryImageIdentity(item.dataset.imageSrc) === variantImageIdentity;
        });

        if (variantMediaIndex >= 0) {
          setActiveMedia(mediaItems[variantMediaIndex].dataset.mediaId, {
            scrollMobile: true,
            scrollDesktop: true,
          });
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionGroups.forEach((group) => {
      qsa('[data-lumi-option-value]', group).forEach((button) => {
        button.addEventListener('click', () => {
          qsa('[data-lumi-option-value]', group).forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          updateVariant();
        });
      });
    });

    const quantityInput = qs('[data-lumi-qty-input]', productPage);
    qs('[data-lumi-qty-minus]', productPage)?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
    });
    qs('[data-lumi-qty-plus]', productPage)?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
    });

    const MODEL_LOAD_TIMEOUT = 20000;
    const modelTimeouts = new WeakMap();
    const initializedViewers = new WeakSet();
    const pendingArViewers = new WeakSet();

    const normalizeModelUrl = (url) => {
      if (!url) return '';
      return url.startsWith('//') ? `${window.location.protocol}${url}` : url;
    };

    const isValidGlbUrl = (url) => typeof url === 'string' && /\.glb(?:\?|$)/i.test(url);
    const isValidUsdzUrl = (url) => typeof url === 'string' && /\.usdz(?:\?|$)/i.test(url);

    const setModelState = (dialog, state, message = '') => {
      const viewer = qs('[data-lumi-model-viewer]', dialog);
      const loading = qs('[data-lumi-model-loading]', dialog);
      const errorBox = qs('[data-lumi-model-error]', dialog);
      if (loading) loading.hidden = state !== 'loading';
      if (errorBox) {
        errorBox.hidden = state !== 'error';
        const copy = qs('p', errorBox);
        if (copy && message) copy.textContent = message;
      }
      viewer?.classList.toggle('is-loaded', state === 'loaded');
    };

    const clearModelTimeout = (viewer) => {
      const timeout = modelTimeouts.get(viewer);
      if (timeout) window.clearTimeout(timeout);
      modelTimeouts.delete(viewer);
    };

    const startModelTimeout = (dialog, viewer) => {
      clearModelTimeout(viewer);
      modelTimeouts.set(viewer, window.setTimeout(() => {
        if (viewer.classList.contains('is-loaded')) return;
        pendingArViewers.delete(viewer);
        setModelState(dialog, 'error', '3D preview is temporarily unavailable.');
      }, MODEL_LOAD_TIMEOUT));
    };

    const initializeModelViewer = (viewer) => {
      if (initializedViewers.has(viewer)) return;
      initializedViewers.add(viewer);
      const dialog = viewer.closest('[data-lumi-product-3d-dialog]');
      if (!dialog) return;
      viewer.addEventListener('load', () => {
        clearModelTimeout(viewer);
        setModelState(dialog, 'loaded');
        if (pendingArViewers.has(viewer)) {
          pendingArViewers.delete(viewer);
          window.requestAnimationFrame(async () => {
            if (viewer.canActivateAR === false || typeof viewer.activateAR !== 'function') {
              setModelState(dialog, 'error', 'AR preview is not supported on this device.');
              return;
            }
            try {
              await viewer.activateAR();
            } catch (error) {
              console.error('Unable to start AR preview:', error);
              setModelState(dialog, 'error', 'AR preview is not supported on this device.');
            }
          });
        }
      });
      viewer.addEventListener('error', (event) => {
        console.error('GLB model failed to load:', event);
        pendingArViewers.delete(viewer);
        clearModelTimeout(viewer);
        setModelState(dialog, 'error', '3D preview is temporarily unavailable.');
      });
      viewer.addEventListener('progress', (event) => {
        const label = qs('[data-lumi-model-loading] span', dialog);
        const progress = event.detail?.totalProgress;
        if (label && Number.isFinite(progress)) label.textContent = `Loading 3D model... ${Math.round(progress * 100)}%`;
      });
      viewer.addEventListener('ar-status', (event) => {
        if (event.detail?.status === 'failed-session') {
          setModelState(dialog, 'error', 'AR preview is not supported on this device.');
        }
      });
    };

    const loadProductModel = async (dialog, selectedModel = {}) => {
      const viewer = qs('[data-lumi-model-viewer]', dialog);
      const modelUrl = normalizeModelUrl(selectedModel.glbUrl || viewer?.dataset.modelUrl);
      const iosModelUrl = normalizeModelUrl(selectedModel.usdzUrl || viewer?.dataset.iosModelUrl);
      if (!viewer || !isValidGlbUrl(modelUrl)) {
        console.error('No valid GLB source found:', selectedModel);
        if (viewer) pendingArViewers.delete(viewer);
        setModelState(dialog, 'error', '3D preview is temporarily unavailable.');
        return;
      }
      initializeModelViewer(viewer);
      setModelState(dialog, 'loading');
      try {
        await Promise.race([
          window.customElements.whenDefined('model-viewer'),
          new Promise((_, reject) => window.setTimeout(() => reject(new Error('model-viewer initialization timed out')), MODEL_LOAD_TIMEOUT)),
        ]);
        if (!dialog.open) return;
        viewer.removeAttribute('src');
        viewer.removeAttribute('ios-src');
        viewer.dataset.modelUrl = modelUrl;
        viewer.dataset.iosModelUrl = isValidUsdzUrl(iosModelUrl) ? iosModelUrl : '';
        if (isValidUsdzUrl(iosModelUrl)) viewer.setAttribute('ios-src', iosModelUrl);
        startModelTimeout(dialog, viewer);
        window.requestAnimationFrame(() => viewer.setAttribute('src', modelUrl));
      } catch (error) {
        console.error('Unable to initialize model-viewer:', error);
        setModelState(dialog, 'error', '3D preview is temporarily unavailable.');
      }
    };

    const closeProduct3d = (dialog) => {
      const viewer = qs('[data-lumi-model-viewer]', dialog);
      if (viewer) {
        pendingArViewers.delete(viewer);
        clearModelTimeout(viewer);
        viewer.pause?.();
        viewer.removeAttribute('src');
        viewer.removeAttribute('ios-src');
        viewer.classList.remove('is-loaded');
      }
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      setModelState(dialog, 'idle');
      document.body.classList.remove('lumi-modal-open');
    };

    const trackProductExperience = (eventName) => {
      const detail = {
        product_id: productPage.dataset.productId || '',
        variant_id: productPage.dataset.currentVariantId || '',
        product_handle: productPage.dataset.productHandle || '',
      };
      window.dispatchEvent(new CustomEvent(eventName, { detail }));
      window.dataLayer?.push({ event: eventName, ...detail });
    };

    qsa('[data-lumi-model-viewer]', productPage).forEach(initializeModelViewer);

    const openProductModelDialog = (trigger, requestAr = false) => {
      const dialog = qs('[data-lumi-product-3d-dialog]', productPage);
      const viewer = dialog ? qs('[data-lumi-model-viewer]', dialog) : null;
      if (!dialog || !viewer) return;
      const glbUrl = normalizeModelUrl(trigger.dataset.modelUrl);
      const usdzUrl = normalizeModelUrl(trigger.dataset.iosModelUrl);
      viewer.setAttribute('alt', trigger.dataset.modelAlt || 'Product 3D model');
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      else dialog.setAttribute('open', '');
      document.body.classList.add('lumi-modal-open');

      if (requestAr) {
        const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent)
          || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (isIos && !isValidUsdzUrl(usdzUrl)) {
          setModelState(dialog, 'error', 'AR preview is not supported on this device.');
          return;
        }
        pendingArViewers.add(viewer);
      }

      loadProductModel(dialog, { glbUrl, usdzUrl });
    };

    productPage.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-lumi-product-3d-trigger]');
      if (trigger) {
        event.preventDefault();
        trackProductExperience('product_3d_open');
        openProductModelDialog(trigger);
        return;
      }

      const arTrigger = event.target.closest('[data-lumi-product-ar-trigger]');
      if (arTrigger) {
        event.preventDefault();
        trackProductExperience('product_ar_click');
        openProductModelDialog(arTrigger, true);
        return;
      }

      if (event.target.closest('[data-lumi-product-customize-link]')) {
        trackProductExperience('product_customize_click');
      }

      const closeButton = event.target.closest('[data-lumi-product-3d-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-lumi-product-3d-dialog]');
        if (dialog) closeProduct3d(dialog);
        return;
      }

      const retryButton = event.target.closest('[data-lumi-retry-model]');
      if (retryButton) {
        const dialog = retryButton.closest('[data-lumi-product-3d-dialog]');
        if (dialog) loadProductModel(dialog);
        return;
      }

      const resetButton = event.target.closest('[data-lumi-reset-model-view]');
      if (resetButton) {
        const viewer = qs('[data-lumi-model-viewer]', resetButton.closest('[data-lumi-product-3d-dialog]'));
        if (!viewer) return;
        viewer.cameraOrbit = 'auto auto auto';
        viewer.cameraTarget = 'auto auto auto';
        viewer.fieldOfView = 'auto';
        viewer.jumpCameraToGoal?.();
        return;
      }

      const rotateButton = event.target.closest('[data-lumi-toggle-model-rotate]');
      if (rotateButton) {
        const viewer = qs('[data-lumi-model-viewer]', rotateButton.closest('[data-lumi-product-3d-dialog]'));
        if (!viewer) return;
        const isRotating = viewer.hasAttribute('auto-rotate');
        viewer.toggleAttribute('auto-rotate', !isRotating);
        rotateButton.setAttribute('aria-pressed', String(!isRotating));
        rotateButton.textContent = isRotating ? 'Start Rotation' : 'Auto Rotate';
        return;
      }

      const fullscreenButton = event.target.closest('[data-lumi-model-fullscreen]');
      if (fullscreenButton) {
        const panel = fullscreenButton.closest('[data-lumi-product-3d-panel]');
        if (document.fullscreenElement) document.exitFullscreen?.();
        else panel?.requestFullscreen?.();
      }
    });

    qsa('[data-lumi-product-3d-dialog]', productPage).forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeProduct3d(dialog);
      });
      dialog.addEventListener('close', () => closeProduct3d(dialog));
    });
  };

  const initializeProductPages = (scope = document) => {
    if (scope instanceof Element && scope.matches('[data-lumi-product-page]')) initializeProductPage(scope);
    qsa('[data-lumi-product-page]', scope).forEach(initializeProductPage);
  };

  initializeProductPages();
  document.addEventListener('shopify:section:load', (event) => initializeProductPages(event.target));
  document.addEventListener('fullscreenchange', () => {
    qsa('[data-lumi-model-fullscreen]').forEach((button) => {
      button.textContent = document.fullscreenElement ? 'Exit Full Screen' : 'Full Screen';
    });
  });
})();
